import { IconProps } from "../../utils/global-types/global-types";

const PauseCircleIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 19 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M9.478 1.5c-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5-3.353-7.5-7.5-7.5m-.938 9.773c0 .36-.15.502-.532.502h-.975c-.383 0-.533-.143-.533-.502V6.728c0-.36.15-.503.533-.503H8c.383 0 .533.143.533.503v4.545zm3.96 0c0 .36-.15.502-.533.502H11c-.383 0-.533-.143-.533-.502V6.728c0-.36.15-.503.533-.503h.967c.383 0 .533.143.533.503z"
    ></path>
  </svg>
);

export default PauseCircleIcon;
